import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useTranslation } from '../../../contexts/translation-context';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const EcomEmailWUT = props => {
  const {
    t
  } = useTranslation();
  const fieldType = FIELD_TYPES.ECOM_EMAIL;
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    type: "email",
    fieldType: fieldType,
    label: t('ecom.email.label')
  }));
};
//# sourceMappingURL=ecom-email-wut.js.map